import { render, staticRenderFns } from "./dianka.vue?vue&type=template&id=a6bce55e&scoped=true"
import script from "./dianka.vue?vue&type=script&lang=js"
export * from "./dianka.vue?vue&type=script&lang=js"
import style0 from "./dianka.vue?vue&type=style&index=0&id=a6bce55e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bce55e",
  null
  
)

export default component.exports